import { put, call, takeLatest } from 'redux-saga/effects'
import { ACTION_TYPES } from 'store/reducers/brokers'
import { getBrokers as getBrokersService } from 'services'
import HTTP_STATUS from 'utils/statusCode'

const {
  BROKERS_REQUEST,
  BROKERS_SUCCESS,
  BROKERS_ERROR
} = ACTION_TYPES

export function *getBrokers() {
  try {
    const response = yield call(getBrokersService)
    yield put({ type: BROKERS_SUCCESS, payload: response.data })
  } catch (err) {
    const { response: { status } = {} } = Object(err)
    ![
      HTTP_STATUS.INTERNAL_SERVER_ERROR,
      HTTP_STATUS.UNAUTHORIZED,
      HTTP_STATUS.UNSUPPORTED_MEDIA_TYPE
    ].includes(status)
    && (yield put({ type: BROKERS_ERROR, payload: err }))
  }
}

export default function *watchBrokers() {
  yield takeLatest(BROKERS_REQUEST, getBrokers)
}
